import { render, staticRenderFns } from "./ResultSearchUser.vue?vue&type=template&id=616944d2&scoped=true&"
import script from "./ResultSearchUser.vue?vue&type=script&lang=js&"
export * from "./ResultSearchUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616944d2",
  null
  
)

export default component.exports